export interface ColumnVO {
  id: string;
  displayName: string;
  field?: string;
  aggFunc?: string;
}